export default __webpack_public_path__ + "static/media/favicon.d7cd3413.ico";